<script setup lang="ts">
// Root component — selects a layout from route meta and wraps RouterView (doc 04 §9).
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useTheme } from 'vuetify'
import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui.store'
import PublicLayout from '@/layouts/PublicLayout.vue'
import AppLayout from '@/layouts/AppLayout.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'

const route = useRoute()
const ui = useUiStore()
const { theme: uiTheme, snackbar } = storeToRefs(ui)
const vuetifyTheme = useTheme()

const layouts = {
  public: PublicLayout,
  app: AppLayout,
  admin: AdminLayout,
  blank: BlankLayout,
} as const

const layout = computed(() => layouts[route.meta.layout ?? 'public'])

// Keep the Vuetify theme in sync with the persisted UI preference.
watch(
  uiTheme,
  (next) => {
    vuetifyTheme.global.name.value = next
  },
  { immediate: true },
)
</script>

<template>
  <v-app>
    <component :is="layout">
      <RouterView v-slot="{ Component }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </component>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="4000">
      {{ snackbar.message }}
    </v-snackbar>
  </v-app>
</template>
